import type { TEnvironment } from "./types";

export const production: TEnvironment = {
  production: true,
  env: "production",
  base: "https://editor.storydoc.com",
  backend: "https://app.storydoc.com/api",
  stories: "https://www.storydoc.com",
  assets: "https://www.storydoc.com/assets/editor",
  featureFlagsCdnUrl: "https://www.storydoc.com/assets/json/feature-flags.json",
  oktaAppId: "0oa4zshf7tQtqFMop5d6",
  securedBucket: "secured-content",
  assetsLink: "https://editor-bundle.storydoc.com",
  mixpanel: "eb638a3319ec60be02adc8580886a03e",
  pdfBackend: "https://headless-service-2dtyk7gj7q-ew.a.run.app",
  generationBackend:
    "https://presentation-generation-59909522358.europe-west1.run.app/presentation-generation",
  frontPublicUrl: "https://www-staging.storydoc.com/assets/editor",
  files: "storydoc-files-production",
  acceptButton: "https://api.storydoc.com/v2/seal",
  assetsBucket: "assets.storydoc.com",
  emailValidationEndpoint: "https://website-2dtyk7gj7q-ew.a.run.app/validate",
  turnstileSiteKey: "0x4AAAAAAAL4-LuW6xeAOp_E",
  hocuspocusUrl: "wss://hocuspocus-59909522358.europe-west1.run.app",
  legacyUrl: "https://app.storydoc.com/",
  mcpUrl: "https://mcp.storydoc.com",
  firebaseConfig: {
    apiKey: "AIzaSyBXHghGOby8NCs9aVEAW-NwYvTsUPblfSU",
    authDomain: "auth.storydoc.com",
    projectId: "platform-production-303007",
  },
  paddle: {
    vendorId: 132577,
    designerAdviceProductId: 794430,
    additionalSeatsSubsId: 795541,
    plans: [
      {
        period: "Monthly",
        title: "Pro",
        price: 60,
        id: "660625",
        seatPrice: 60,
        active: true,
        seats: 1,
      },
      {
        period: "Annually",
        title: "Pro",
        price: 540,
        id: "660626",
        seatPrice: 540,
        seats: 1,
      },
      {
        period: "Annually",
        title: "Pro",
        price: 360,
        id: "904482",
        seatPrice: 360,
        seats: 1,
      },
      {
        period: "Annually",
        title: "Pro",
        price: 432,
        id: "905853",
        seatPrice: 432,
        active: true,
        seats: 1,
      },
      {
        period: "Annually",
        title: "Pro",
        price: 288,
        id: "905853",
        seatPrice: 288,
        earlyBird: true,
        seats: 1,
      },
      {
        period: "Monthly",
        title: "Starter",
        price: 50,
        id: "666308",
        seatPrice: 50,
        legacy: true,
        seats: 1,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 360,
        id: "666309",
        seatPrice: 360,
        legacy: true,
        seats: 1,
      },
      {
        period: "Monthly",
        title: "Starter",
        price: 40,
        id: "800988",
        seats: 1,
        seatPrice: 40,
      },
      {
        period: "Monthly",
        title: "Starter",
        price: 20,
        id: "910123",
        seats: 1,
        seatPrice: 20,
      },
      {
        period: "Monthly",
        title: "Starter",
        price: 25,
        id: "913910",
        seats: 1,
        seatPrice: 25,
      },
      {
        period: "Monthly",
        title: "Starter",
        price: 29,
        id: "915766",
        seats: 1,
        seatPrice: 29,
      },
      {
        period: "Monthly",
        title: "Starter",
        price: 33,
        id: "921549",
        seats: 1,
        seatPrice: 33,
        active: true,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 120,
        id: "913912",
        seats: 1,
        seatPrice: 120,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 360,
        id: "800987",
        seats: 1,
        seatPrice: 360,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 240,
        id: "904483",
        seats: 1,
        seatPrice: 240,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 288,
        id: "905854",
        seats: 1,
        seatPrice: 288,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 144,
        id: "910124",
        seats: 1,
        seatPrice: 144,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 180,
        id: "913911",
        seats: 1,
        seatPrice: 180,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 208,
        id: "915767",
        seats: 1,
        seatPrice: 208,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 237.6,
        id: "921550",
        seats: 1,
        seatPrice: 237.6,
        active: true,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 96,
        id: "911143",
        seats: 1,
        seatPrice: 96,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 139,
        id: "915767",
        seats: 1,
        seatPrice: 139,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 158.4,
        id: "921550",
        seats: 1,
        seatPrice: 158.4,
        earlyBird: true,
      },
      {
        period: "Monthly",
        title: "Premium",
        price: 500,
        id: "660627",
        seatPrice: 500,
        active: true,
        seats: 1,
      },
      {
        period: "Annually",
        title: "Premium",
        price: 4800,
        id: "660628",
        seatPrice: 4800,
        active: true,
        seats: 1,
      },
      {
        period: "Annually",
        title: "Premium",
        price: 720,
        id: "915975",
        seats: 1,
        seatPrice: 720,
        active: true,
      },
    ],
  },
  appSumo: {
    plans: [
      {
        period: "Lifetime",
        title: "AppSumo License Tier 1 Lifetime plan",
        price: 69,
        id: "storydoc_tier1",
        seats: 1,
        seatPrice: 40,
      },
      {
        period: "Lifetime",
        title: "AppSumo License Tier 2 Lifetime plan",
        price: 149,
        id: "storydoc_tier2",
        seats: 5,
        seatPrice: 40,
      },
      {
        period: "Lifetime",
        title: "AppSumo License Tier 3 Lifetime plan",
        price: 309,
        id: "storydoc_tier3",
        seats: 15,
        seatPrice: 40,
      },
    ],
  },
};
